import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthContext } from '../../hooks/useAuthContext';
import { apiFetch } from '../../utils/api';
import { formatBlogDate } from '../../utils/blogUtils';
import Button from '../../components/Button/Button';
import IconButton from '../../components/IconButton/IconButton';
import ConfirmModal from '../../components/ConfirmModal/ConfirmModal';
import Spinner from '../../components/Spinner/Spinner';
import './AdminBlogPage.css';

const STATUS_LABELS = { draft: 'Draft', published: 'Published' };

const AdminBlogPage = () => {
  const { user } = useAuthContext();
  const navigate = useNavigate();
  const [posts, setPosts] = useState(null);
  const [postToDelete, setPostToDelete] = useState(null);

  useEffect(() => {
    const fetchPosts = async () => {
      const res = await apiFetch('/api/admin/blog', {
        headers: { Authorization: `Bearer ${user.token}` },
      });
      setPosts(res.ok ? await res.json() : []);
    };
    fetchPosts();
  }, [user.token]);

  const deletePost = async () => {
    const { _id } = postToDelete;
    setPostToDelete(null);
    const res = await apiFetch(`/api/admin/blog/${_id}`, {
      method: 'DELETE',
      headers: { Authorization: `Bearer ${user.token}` },
    });
    if (res.ok) setPosts(prev => prev.filter(p => p._id !== _id));
  };

  if (!posts) return <Spinner />;

  return (
    <div className="admin-blog-page">
      <div className="admin-blog-header">
        <h2>Blog Posts</h2>
        <Button variant="secondary" onClick={() => navigate('/admin/blog/new')}>
          New Post
        </Button>
      </div>

      {posts.length === 0 && <p className="admin-blog-empty">No posts yet.</p>}

      <ul className="admin-blog-list">
        {posts.map(post => (
          <li key={post._id} className="admin-blog-row clickable" onClick={() => navigate(`/admin/blog/${post._id}`)}>
            <div className="admin-blog-row-main">
              <span className="admin-blog-row-title">{post.title?.en || 'Untitled'}</span>
              <span className="admin-blog-row-meta">
                Updated {formatBlogDate(post.updatedAt, 'en')}
              </span>
            </div>
            <span className={`admin-blog-status admin-blog-status--${post.status}`}>
              {STATUS_LABELS[post.status]}
            </span>
            <IconButton
              icon="delete"
              variant="danger"
              onClick={(e) => { e.stopPropagation(); setPostToDelete(post); }}
              aria-label="Delete post"
            />
          </li>
        ))}
      </ul>

      {postToDelete && (
        <ConfirmModal
          title={`Delete "${postToDelete.title?.en || 'Untitled'}"?`}
          message="This will permanently delete the post. This cannot be undone."
          confirmLabel="Delete"
          onConfirm={deletePost}
          onCancel={() => setPostToDelete(null)}
        />
      )}
    </div>
  );
};

export default AdminBlogPage;
